<div class="tw-flex tw-items-center" [ngClass]="size === 'sm' ? 'tw-gap-2.5' : 'tw-gap-5'">
  @if (showImage) {
    <div
      class="p-skeleton-image tw-flex-shrink-0"
      [ngClass]="size === 'sm' ? 'tw-h-10 tw-w-10' : 'tw-h-20 tw-w-20'"
    >
      <img
        class="logo-image tw-flex-shrink-0 !tw-object-cover"
        [ngClass]="
          size === 'sm'
            ? 'tw-h-10 tw-w-10 tw-border tw-border-solid tw-border-divider !tw-shadow-none'
            : ''
        "
        [alt]="name"
        [src]="imageUrl || defaultLogo"
      />
    </div>
  }

  <div class="tw-w-full">
    <!-- Defaults -->
    <!-- Page header -->
    @if (size === 'lg') {
      <h1 class="p-skeleton-bar p-text-h2 tw-break-words" [ngClass]="nameClass">
        <span>{{ name }}</span>
        <div class="tw-mt-2.5 tw-flex tw-items-center tw-gap-2">
          <ng-content></ng-content>
          @if (description) {
            <small class="p-skeleton-bar p-text-p" [ngClass]="descriptionClass">
              {{ description }}
            </small>
          }
        </div>
      </h1>
    }

    <!-- Normal thumbnail -->
    @if (size === 'sm') {
      @if (name) {
        <div
          class="p-skeleton-bar company-name tw-line-clamp-1 tw-font-bold tw-text-black"
          [ngClass]="nameClass"
        >
          {{ name }}
        </div>
      }
      @if (description) {
        <div>
          <div
            class="p-skeleton-bar tw-line-clamp-1 tw-text-body tw-text-opacity-70"
            [ngClass]="descriptionClass"
          >
            {{ description }}
          </div>
        </div>
      }
    }
  </div>
</div>
